import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, text, ButtonText, margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`Advantage ${margin}`}>
        <div className="Advantage-container Container">
          <RichText
            tagName="h2"
            className="Typography title-6 center color-black margin-extra-small"
            value={title}
            placeholder="Mais vantagens para quem assina"
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />

          <RichText
            tagName="p"
            className="Typography text center grey margin-medium"
            value={text}
            placeholder="Texto"
            keepPlaceholderOnFocus
            onChange={(text) => setAttributes({ text })}
          />

          <div className="Advantage-wrap">
            <InnerBlocks
              template={[['app/item-advantage']]}
              allowedBlocks={['app/item-advantage']}
            />
          </div>
        </div>

        <RichText
          tagName="span"
          className="Advantage-button Button Button-center"
          value={ButtonText}
          placeholder="Texto"
          keepPlaceholderOnFocus
          onChange={(ButtonText) => setAttributes({ ButtonText })}
        />
      </section>
    </>
  );
};

export default Edit;
